import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import PageContext from '../../../config/page-settings.js';

import ActivityLogsList from './ActivityLogsList.js';

const ActivityLogs = (props) => {
  const pageContext = useContext(PageContext);

  useEffect(() => {
    pageContext.handleSetPageSidebar(true);
    pageContext.handleSetPageHeader(true);
    pageContext.handleSetPageContentFullWidth(false);
  }, []);

  return (
    <div>
      <h1 className="page-header">Activity Logs</h1>
      <ActivityLogsList />
    </div>
  );
};

export default withRouter(ActivityLogs);
